// Shared audio state across all music components
// Once the user interacts with any audio control, all music auto-plays

let _userHasInteracted = false;

export function getUserHasInteracted() {
  return _userHasInteracted;
}

export function setUserHasInteracted(value = true) {
  _userHasInteracted = value;
}
